var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineFlexBaggage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2765_1706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.02108 12.2305C1.16036 13.1712 1.96608 13.8526 2.91322 13.9319C4.39179 14.0573 5.92608 14.1955 7.5 14.1955C9.09643 14.1955 10.6436 14.1076 12.1425 13.9694C12.5907 13.932 13.0134 13.7452 13.3428 13.4391C13.6723 13.1329 13.8895 12.7251 13.9596 12.2808C14.1117 11.2934 14.1908 10.296 14.1964 9.29691C14.1964 8.26513 14.1129 7.25156 13.965 6.27549C13.8289 5.37763 13.0843 4.70906 12.18 4.62441C10.6243 4.47684 9.06265 4.40176 7.5 4.39941C5.88215 4.39941 4.30179 4.47763 2.78786 4.62227C1.89965 4.70691 1.16679 5.36049 1.03179 6.24227C0.732946 8.22725 0.729336 10.2455 1.02108 12.2316M4.92429 14.0916V4.48727M10.0757 14.1173V4.48727",
    stroke: "#12234F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.559 4.47112V3.86362C10.559 3.05234 10.2367 2.27429 9.66308 1.70063C9.08942 1.12697 8.31137 0.804688 7.50009 0.804688C6.68881 0.804688 5.91076 1.12697 5.3371 1.70063C4.76344 2.27429 4.44116 3.05234 4.44116 3.86362V4.47112",
    stroke: "#12234F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2765_1706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineFlexBaggage);
export default __webpack_public_path__ + "static/media/streamline-flex_baggage.1a3e5717f552b2f55b756381a9275413.svg";
export { ForwardRef as ReactComponent };